// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FunnelPlotFilledSvg from "@fishx/icons-svg/es/asn/FunnelPlotFilled";
import FishxIcon from '../components/FishxIcon';

var FunnelPlotFilled = function FunnelPlotFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FunnelPlotFilledSvg
  }));
};

FunnelPlotFilled.displayName = 'FunnelPlotFilled';
export default React.forwardRef(FunnelPlotFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FunnelPlotFilled.js
// module id = 2858
// module chunks = 0